// For page-features-index.php
const startAllFunctionalitiesTab = () => {
  const tabsFeatures = document.querySelector('.features .c-tabs');
  if (!tabsFeatures) return;

  const tabIndicators = tabsFeatures.querySelectorAll('.c-tabs__tab-indicator');

  tabIndicators.forEach((indicator, index) => {
    indicator.addEventListener('click', (e) => {
      e.preventDefault();
      const dataHref = indicator.getAttribute('data-href');
      indicator.parentElement.setAttribute('data-href', dataHref);

      tabIndicators.forEach(ind => {
        ind.classList.remove('active');
      });

      indicator.parentElement.setAttribute('data-active-tab', index + 1);
      indicator.classList.add('active');
    });
  });
};

document.addEventListener('DOMContentLoaded', startAllFunctionalitiesTab);
